import { paywallCheckout } from "@circle-react/helpers/urlHelpers/internalApi/paywalls/checkout";
import { useMutation, useQueryClient } from "react-query";
import type { UseMutationResult } from "react-query";

import type { ApiError } from "@/react/config/CustomErrors";
import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import type {
  CheckoutSession,
  CheckoutSessionStepStatus,
} from "@/react/types/Paywalls/Checkout/Session";

import { updateSessionCache } from "../../helpers/sessions/updateSessionCache";

interface UpdateSessionStepParams {
  paywallId: number;
  status: CheckoutSessionStepStatus;
  stepId: number;
}

interface UpdateSessionStepBody {
  session_step: {
    status: CheckoutSessionStepStatus;
  };
}

export const useUpdateSessionStep = (): UseMutationResult<
  CheckoutSession,
  ApiError,
  UpdateSessionStepParams
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdateSessionStepParams) => {
      const url = paywallCheckout.sessionStep.update({
        stepId: params.stepId,
        paywallId: params.paywallId,
      });

      const body: UpdateSessionStepBody = {
        session_step: {
          status: params.status,
        },
      };

      return reactQueryPatch<CheckoutSession, UpdateSessionStepBody>(url, body);
    },
    onSuccess: (
      updatedSession: CheckoutSession,
      variables: UpdateSessionStepParams,
    ) => {
      updateSessionCache(queryClient, variables.paywallId, updatedSession);
    },
    onError: (error: ApiError) => {
      console.error(error.message);
    },
  });
};
